import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRegionFlagQueryVariables = Types.Exact<{
  flagId: Types.Scalars['Long']['input'];
}>;


export type GetRegionFlagQuery = { genomeViewer: { regionFlag: { region: { contig: { id: number, length: number, organism: { id: number } } | null, range: { start: number, stop: number } | null } | null } | null } | null };

export type GetRegionFlagsQueryVariables = Types.Exact<{
  contigId: Types.Scalars['Long']['input'];
}>;


export type GetRegionFlagsQuery = { contig: { length: number, flags: Array<{ id: number, name: string | null, description: string | null, color: string | null, deletable: boolean | null, created: string, modified: string, shared: boolean | null, lastModifier: { username: string | null } | null, creator: { username: string | null } | null, project: { id: number, name: string, color: string | null } | null, region: { contig: { sequenceId: string } | null, range: { start: number, stop: number } | null } | null, itemTags: Array<{ id: number, name: string, color: string | null } | null> | null }> } | null };

export type CreateRegionFlagMutationVariables = Types.Exact<{
  input: Types.InputRegionFlagInput;
}>;


export type CreateRegionFlagMutation = { createRegionFlag: { id: number } | null };

export type UpdateRegionFlagMutationVariables = Types.Exact<{
  flagId: Types.Scalars['Long']['input'];
  input: Types.InputRegionFlagUpdateInput;
}>;


export type UpdateRegionFlagMutation = { updateRegionFlag: { id: number } | null };

export type DeleteRegionFlagsMutationVariables = Types.Exact<{
  regionFlagIds: Array<Types.InputMaybe<Types.Scalars['Long']['input']>> | Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type DeleteRegionFlagsMutation = { deleteRegionFlags: Array<{ id: number } | null> | null };

export type ProjectColoredWidgetFragment = { id: number, name: string, color: string | null };

export type RangeFragment = { range: { start: number, stop: number } | null };

export const ProjectColoredWidgetFragmentDoc = gql`
    fragment ProjectColoredWidget on Project {
  id
  name
  color
}
    `;
export const RangeFragmentDoc = gql`
    fragment Range on Region {
  range {
    start
    stop
  }
}
    `;
export const GetRegionFlagDocument = gql`
    query getRegionFlag($flagId: Long!) {
  genomeViewer {
    regionFlag(flagId: $flagId) {
      region {
        contig {
          id
          length
          organism {
            id
          }
        }
        ...Range
      }
    }
  }
}
    ${RangeFragmentDoc}`;

/**
 * __useGetRegionFlagQuery__
 *
 * To run a query within a React component, call `useGetRegionFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionFlagQuery({
 *   variables: {
 *      flagId: // value for 'flagId'
 *   },
 * });
 */
export function useGetRegionFlagQuery(baseOptions: Apollo.QueryHookOptions<GetRegionFlagQuery, GetRegionFlagQueryVariables> & ({ variables: GetRegionFlagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionFlagQuery, GetRegionFlagQueryVariables>(GetRegionFlagDocument, options);
      }
export function useGetRegionFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionFlagQuery, GetRegionFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionFlagQuery, GetRegionFlagQueryVariables>(GetRegionFlagDocument, options);
        }
export function useGetRegionFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionFlagQuery, GetRegionFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionFlagQuery, GetRegionFlagQueryVariables>(GetRegionFlagDocument, options);
        }
export type GetRegionFlagQueryHookResult = ReturnType<typeof useGetRegionFlagQuery>;
export type GetRegionFlagLazyQueryHookResult = ReturnType<typeof useGetRegionFlagLazyQuery>;
export type GetRegionFlagSuspenseQueryHookResult = ReturnType<typeof useGetRegionFlagSuspenseQuery>;
export type GetRegionFlagQueryResult = Apollo.QueryResult<GetRegionFlagQuery, GetRegionFlagQueryVariables>;
export const GetRegionFlagsDocument = gql`
    query getRegionFlags($contigId: Long!) {
  contig(contigId: $contigId) {
    length
    flags {
      id
      name
      description
      color
      deletable
      created
      modified
      shared
      lastModifier {
        username
      }
      creator {
        username
      }
      project {
        ...ProjectColoredWidget
      }
      region {
        ...Range
        contig {
          sequenceId
        }
      }
      itemTags {
        id
        name
        color
      }
    }
  }
}
    ${ProjectColoredWidgetFragmentDoc}
${RangeFragmentDoc}`;

/**
 * __useGetRegionFlagsQuery__
 *
 * To run a query within a React component, call `useGetRegionFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionFlagsQuery({
 *   variables: {
 *      contigId: // value for 'contigId'
 *   },
 * });
 */
export function useGetRegionFlagsQuery(baseOptions: Apollo.QueryHookOptions<GetRegionFlagsQuery, GetRegionFlagsQueryVariables> & ({ variables: GetRegionFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionFlagsQuery, GetRegionFlagsQueryVariables>(GetRegionFlagsDocument, options);
      }
export function useGetRegionFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionFlagsQuery, GetRegionFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionFlagsQuery, GetRegionFlagsQueryVariables>(GetRegionFlagsDocument, options);
        }
export function useGetRegionFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionFlagsQuery, GetRegionFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionFlagsQuery, GetRegionFlagsQueryVariables>(GetRegionFlagsDocument, options);
        }
export type GetRegionFlagsQueryHookResult = ReturnType<typeof useGetRegionFlagsQuery>;
export type GetRegionFlagsLazyQueryHookResult = ReturnType<typeof useGetRegionFlagsLazyQuery>;
export type GetRegionFlagsSuspenseQueryHookResult = ReturnType<typeof useGetRegionFlagsSuspenseQuery>;
export type GetRegionFlagsQueryResult = Apollo.QueryResult<GetRegionFlagsQuery, GetRegionFlagsQueryVariables>;
export const CreateRegionFlagDocument = gql`
    mutation createRegionFlag($input: InputRegionFlagInput!) {
  createRegionFlag(regionFlagInputData: $input) {
    id
  }
}
    `;
export type CreateRegionFlagMutationFn = Apollo.MutationFunction<CreateRegionFlagMutation, CreateRegionFlagMutationVariables>;

/**
 * __useCreateRegionFlagMutation__
 *
 * To run a mutation, you first call `useCreateRegionFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegionFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegionFlagMutation, { data, loading, error }] = useCreateRegionFlagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRegionFlagMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegionFlagMutation, CreateRegionFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegionFlagMutation, CreateRegionFlagMutationVariables>(CreateRegionFlagDocument, options);
      }
export type CreateRegionFlagMutationHookResult = ReturnType<typeof useCreateRegionFlagMutation>;
export type CreateRegionFlagMutationResult = Apollo.MutationResult<CreateRegionFlagMutation>;
export type CreateRegionFlagMutationOptions = Apollo.BaseMutationOptions<CreateRegionFlagMutation, CreateRegionFlagMutationVariables>;
export const UpdateRegionFlagDocument = gql`
    mutation updateRegionFlag($flagId: Long!, $input: InputRegionFlagUpdateInput!) {
  updateRegionFlag(flagId: $flagId, regionFlagUpdateInputData: $input) {
    id
  }
}
    `;
export type UpdateRegionFlagMutationFn = Apollo.MutationFunction<UpdateRegionFlagMutation, UpdateRegionFlagMutationVariables>;

/**
 * __useUpdateRegionFlagMutation__
 *
 * To run a mutation, you first call `useUpdateRegionFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegionFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegionFlagMutation, { data, loading, error }] = useUpdateRegionFlagMutation({
 *   variables: {
 *      flagId: // value for 'flagId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegionFlagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegionFlagMutation, UpdateRegionFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegionFlagMutation, UpdateRegionFlagMutationVariables>(UpdateRegionFlagDocument, options);
      }
export type UpdateRegionFlagMutationHookResult = ReturnType<typeof useUpdateRegionFlagMutation>;
export type UpdateRegionFlagMutationResult = Apollo.MutationResult<UpdateRegionFlagMutation>;
export type UpdateRegionFlagMutationOptions = Apollo.BaseMutationOptions<UpdateRegionFlagMutation, UpdateRegionFlagMutationVariables>;
export const DeleteRegionFlagsDocument = gql`
    mutation deleteRegionFlags($regionFlagIds: [Long]!) {
  deleteRegionFlags(regionFlagIds: $regionFlagIds) {
    id
  }
}
    `;
export type DeleteRegionFlagsMutationFn = Apollo.MutationFunction<DeleteRegionFlagsMutation, DeleteRegionFlagsMutationVariables>;

/**
 * __useDeleteRegionFlagsMutation__
 *
 * To run a mutation, you first call `useDeleteRegionFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegionFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegionFlagsMutation, { data, loading, error }] = useDeleteRegionFlagsMutation({
 *   variables: {
 *      regionFlagIds: // value for 'regionFlagIds'
 *   },
 * });
 */
export function useDeleteRegionFlagsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegionFlagsMutation, DeleteRegionFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegionFlagsMutation, DeleteRegionFlagsMutationVariables>(DeleteRegionFlagsDocument, options);
      }
export type DeleteRegionFlagsMutationHookResult = ReturnType<typeof useDeleteRegionFlagsMutation>;
export type DeleteRegionFlagsMutationResult = Apollo.MutationResult<DeleteRegionFlagsMutation>;
export type DeleteRegionFlagsMutationOptions = Apollo.BaseMutationOptions<DeleteRegionFlagsMutation, DeleteRegionFlagsMutationVariables>;